import axios from 'axios';
import i18n from "@/i18n"; // Import the i18n instance
import { fetchTokenQuery, logout } from '@/queries/user.query';
import { queryClient } from '@/queries/queryClient';
import { UAParser } from 'ua-parser-js';
import FingerprintJS from '@fingerprintjs/fingerprintjs'

// Initialize the agent at application startup.
const fpPromise = FingerprintJS.load();
const parser = new UAParser(navigator.userAgent);
const ua = parser.getResult().withClientHints();

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    "Yuzu-Key": import.meta.env.VITE_API_KEY,
  },
});

api.interceptors.request.use(
  async (config) => {
    const fp = await fpPromise;
    const fingerPrintResult = await fp.get();
    const currentLocale = i18n.global.locale;
    
    let uaWithClientHints = await ua;
    delete uaWithClientHints.ua;
    
    const encodedBrowserInfo = btoa(String.fromCodePoint(...new TextEncoder().encode(JSON.stringify(uaWithClientHints))));

    config.headers["lang"] = currentLocale.value;
    config.headers["Accept-Language"] = currentLocale.value === 'fr' ? 'fr;q=0.9, en;q=0.8' : 'en;q=0.9, fr;q=0.8';
    config.headers["x-browser-fingerprint"] = fingerPrintResult.visitorId;
    config.headers["x-device-infos"] = encodedBrowserInfo;
    config.headers["x-app-name"] = 'frontend-orga';
    config.headers["x-app-environment"] = import.meta.env.VITE_ENV || 'dev';

    const tokenObject = await fetchTokenQuery();
    if (tokenObject) {
      config.headers["Authorization"] = `Bearer ${tokenObject.token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log(error);
    if (error.response.status === 401) {
      // Remove token, clear user states and go to login page
      console.error("Unauthorized, logging out ...");
      logout();
      queryClient.clear();
    }
    throw error;
  }
);

export { api };